<template>
	<div
		class="authPage"
		:class="{
			'is-mainExpanded': ['register', 'resetPassword'].includes(screen),
		}"
	>
		<BHeader
			class="authPage__header"
			width="full"
			backgroundMobile="auth-page-splash.jpg"
			backgroundDesktop="transparent"
			:increasedHeightMobile="true"
		/>

		<div class="authPage__body">
			<div class="authPage__splash"></div>

			<div class="authPage__main">
				<component :is="componentsByScreen[screen]" />
			</div>
		</div>
	</div>
</template>

<script>
import BIcon from "@/components/base/BIcon";
import BBtn from "@/components/base/BBtn";
import BLangSelector from "@/components/base/BLangSelector";
import { BDropdown, BDropdownItem } from "@/components/base/BDropdown/index.js";

import LoginScreen from "./LoginScreen.vue";
import RegisterScreen from "./RegisterScreen.vue";
import ForgotPasswordScreen from "./ForgotPasswordScreen.vue";
import ResetPasswordScreen from "./ResetPasswordScreen.vue";
import BHeader from "../../components/base/BHeader.vue";

export default {
	components: {
		BIcon,
		BLangSelector,
		BDropdown,
		BDropdownItem,
		BBtn,
		BHeader,
	},
	props: {
		screen: {
			type: String,
			default: "login",
		},
	},
	data() {
		return {
			componentsByScreen: {
				login: LoginScreen,
				register: RegisterScreen,
				forgotPassword: ForgotPasswordScreen,
				resetPassword: ResetPasswordScreen,
			},
		};
	},
	computed: {},
	methods: {},
};
</script>

<style lang="scss">
.authPage {
	min-height: 100vh;
	min-height: 100dvh;
	display: flex;
	flex-direction: column;
}

.authPage__body {
	display: grid;
	grid-template-columns: 1fr minmax(auto, 550px);
	flex-grow: 1;
	margin-top: calc(-1 * var(--header-height));

	:where(.is-mainExpanded) & {
		grid-template-columns: 1fr minmax(auto, 850px);
	}
}

.authPage__splash {
	background-color: var(--color-primary-800);
	background-image: url("../../assets/img/auth-page-splash.jpg");
	background-size: cover;
	background-position: top center;
	padding-block: var(--header-height);
}

.authPage__main {
	background: var(--color-neutral-75);
	padding-inline: 91px;
	padding-block: var(--header-height);
}

.authPage__backLink {
	display: flex;
	align-items: center;
	gap: 20px;
}

.authPage__userDropdownToggle {
	--size: 45px;
	width: var(--size);
	height: var(--size);
	border-radius: 50%;
	background-color: var(--color-primary-800);
}

.authPage__headerMain {
	margin-left: auto;
	display: flex;
	gap: 40px;
	align-items: center;
}

.autPage__headerLinks {
	display: flex;
	gap: 40px;
}

.authPage__headerLink {
	color: var(--color-primary-700);
	font-weight: var(--font-weight-medium);
	cursor: pointer;

	&:hover {
		color: var(--color-primary-800);
	}

	&:active {
		color: var(--color-primary-900);
	}
}

.authPage__headerOtherLinks {
	display: flex;
	gap: 14px;
}

.authPage__text {
	margin-bottom: 56px;
}

.authPage__title {
	font-size: var(--font-size-xl);
	line-height: 1.11;
	margin-bottom: 20px;
}

.authPage__titleLine1 {
	font-weight: var(--font-weight-bold);
	color: var(--color-primary-800);
}

.authPage__titleLine2 {
	font-weight: var(--font-weight-light);
	color: var(--color-primary-600);
}

.authPage__lead {
	font-size: var(--font-size-s);
	color: var(--color-neutral-500);
}

.authPage__passwordStrengthMeter {
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 20px;
}

.authPage__passwordRuleItem {
	display: flex;
	font-size: var(--font-size-xs);
	color: var(--color-primary-900);
}

.authPage__passwordRuleCheck {
	--size: 16px;
	width: var(--size);
	height: var(--size);
	border-radius: 50%;
	border: 1px solid var(--color-neutral-300);
	margin-right: 8px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: var(--color-primary-600);
	flex-shrink: 0;
}

.authPage__passwordRuleCheckIcon {
	display: none;
	color: var(--color-success-400);
}

.authPage__passwordRuleCheck {
	&.is-checked {
		border-color: var(--color-success-400);

		.authPage__passwordRuleCheckIcon {
			display: block;
		}
	}
}

.authPage__submitError {
	background: var(--color-error-100);
	color: var(--color-error-400);
	padding: 1rem;
	border-left: 1px solid;
	gap: 20px;
}

.authPage__mainExpandedFormFooter {
	display: flex;
	align-items: center;
	gap: 20px;
}

@media (max-width: 768px) {
	.authPage__body {
		grid-template-columns: 1fr;
	}

	.authPage__splash {
		display: none;
	}

	.authPage__main {
		padding-block: 40px;
	}

	.authPage__form .d-grid--2 {
		grid-template-columns: 1fr;
	}
}

@media (max-width: 540px) {
	.authPage__main {
		padding-inline: 40px;
	}
}

@media (max-width: 445px) {
	.authPage__mainExpandedFormFooter {
		flex-direction: column;
		align-items: stretch;
	}
}
</style>
